<template>
    <v-container fluid>
        <v-btn
            :loading="subscribeFormSubmissionsWithInfo === null"
            @click="showSubscribeFormLinkGenerator = true"
            bottom
            class="mb-10"
            color="secondary darken-1"
            fab
            fixed
            right
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-row
            align="center"
            no-gutters
        >
            <v-col
                cols="12"
                justify="center"
                lg="4"
                sm="6"
            >
                <v-subheader>
                    <h2>Subscribe Form Submissions ({{totalMatches}})</h2>
                </v-subheader>
            </v-col>
            <v-col
                cols="12"
                lg="4"
                sm="6"
            >
                <v-text-field
                    @click:clear="setSearch('')"
                    @input="setSearch"
                    clearable
                    label="Search"
                    prepend-icon="mdi-magnify"
                    single-line
                />
            </v-col>
            <v-col
                class="text-right"
                cols="12"
                lg="4"
                sm="6"
            >
                <!--<v-btn
                    @click="showFilters = !showFilters"
                    color="secondary darken-1"
                    icon
                >
                    <v-icon>mdi-tune</v-icon>
                </v-btn>-->
            </v-col>
        </v-row>
        <v-container class="pb-10">
            <v-row
                justify="center"
                v-if="subscribeFormSubmissionsWithInfo === null"
            >
                <v-col
                    :key="i"
                    cols="12"
                    lg="6"
                    v-for="i in 6"
                >
                    <v-skeleton-loader
                        elevation="4"
                        type="card"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row
                justify="center"
                v-else
            >
                <v-col
                    :key="subscribeFormSubmissionWithInfo.entity.id"
                    cols="12"
                    v-for="subscribeFormSubmissionWithInfo in subscribeFormSubmissionsWithInfo"
                >
                    <!--@click="loadSubscribeFormSubmissionForm(subscribeFormSubmissionWithInfo.entity)"-->
                    <v-card
                        @click="loadSubscribeFormSubmissionForm(subscribeFormSubmissionWithInfo.entity)"
                        class="entity-card fill-height"
                        elevation="4"
                        style="overflow:hidden"
                    >
                        <v-card-text>
                            <v-row>
                                <v-col
                                    cols="12"
                                    lg="6"
                                >
                                    <h5>
                                        Status: {{getStatusName(subscribeFormSubmissionWithInfo.entity.accisureFormStatus)}}
                                        <br />
                                        Initials: {{subscribeFormSubmissionWithInfo.entity.initials}}
                                        <br />
                                        Surname: {{subscribeFormSubmissionWithInfo.entity.surname}}
                                        <br />
                                        Identity Number: {{subscribeFormSubmissionWithInfo.entity.identityNumber}}
                                        <br />
                                        Cell: {{subscribeFormSubmissionWithInfo.entity.cellNumber}}
                                        <br />
                                        Email: {{subscribeFormSubmissionWithInfo.entity.email}}
                                    </h5>
                                </v-col>
                                <v-col
                                    cols="12"
                                    lg="6"
                                >
                                    <v-card
                                        @click.stop
                                        class="mt-5"
                                        no-gutters
                                        v-if="subscribeFormSubmissionWithInfo.entity.identityFileId > 0"
                                    >
                                        <v-card-text class="py-0">
                                            <v-row>
                                                <v-col
                                                    align-self="center"
                                                    cols="8"
                                                >
                                                    <strong>Identity Document</strong>
                                                </v-col>

                                                <v-col
                                                    align-self="center"
                                                    class="text-center"
                                                    cols="4"
                                                >
                                                    <v-btn
                                                        @click.stop="
                      $store.dispatch('files/get', {
                        fileId: subscribeFormSubmissionWithInfo.entity.identityFileId,
                        namePrefix:
                          subscribeFormSubmissionWithInfo.entity.id.toString() + '_IdentityDocument'
                      })"
                                                        fab
                                                        small
                                                    >
                                                        <h3>
                                                            <v-icon color="light-blue">mdi-download</v-icon>
                                                        </h3>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>

                                    <v-card
                                        @click.stop
                                        class="mt-5"
                                        no-gutters
                                        v-if="subscribeFormSubmissionWithInfo.entity.subscribeFormFileId > 0"
                                    >
                                        <v-card-text class="py-0">
                                            <v-row>
                                                <v-col
                                                    align-self="center"
                                                    cols="8"
                                                >
                                                    <strong>Application Form</strong>
                                                </v-col>

                                                <v-col
                                                    align-self="center"
                                                    class="text-center"
                                                    cols="4"
                                                >
                                                    <v-btn
                                                        @click.stop="
                      $store.dispatch('files/get', {
                        fileId: subscribeFormSubmissionWithInfo.entity.subscribeFormFileId,
                        namePrefix:
                          subscribeFormSubmissionWithInfo.entity.id.toString() + '_ApplicationForm'
                      })"
                                                        fab
                                                        small
                                                    >
                                                        <h3>
                                                            <v-icon color="light-blue">mdi-download</v-icon>
                                                        </h3>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>


        <v-dialog
            persistent
            v-model="showSubscribeFormLinkGenerator"
            width="500px"
        >
            <SubscribeFormLinkGenerator
                @close="showSubscribeFormLinkGenerator = false"
            />
        </v-dialog>

        <v-dialog
            persistent
            v-model="subscribeFormSubmissionFormVisible"
            width="500px"
        >
            <SubscribeFormSubmissionForm
                :entity-in="subscribeFormSubmissionFormSubscribeFormSubmission"
                :key="subscribeFormSubmissionFormKey"
                @close="closeSubscribeFormSubmissionForm"
                @deleted="deleteSubscribeFormSubmission"
                @saved="updateSubscribeFormSubmission"
            />
        </v-dialog>

        <v-pagination
            :length="pagesCount"
            @input="paginationDebounce(500, true)"
            class="pagination-bar base-background"
            total-visible="7"
            v-model="pageNo"
            v-show="pagesCount > 1"
        ></v-pagination>
    </v-container>
</template>

<script>
//import SubscribeFormSubmission from "../models/SubscribeFormSubmission.model";
import uuid4 from "../helpers/uuid4";
import SubscribeFormSubmission from "../models/SubscribeFormSubmission.model";
import SubscribeFormSubmissionForm from "../components/forms/SubscribeFormSubmissionForm";
import SubscribeFormLinkGenerator from "../components/forms/SubscribeFormLinkGenerator";

export default {
    name: "SubscribeFormSubmissions",
    props: ["status"],
    data: function() {
        return {
            //main data
            statuses: [
                { name: "Unattended", value: 1 },
                { name: "Accepted", value: 2 },
                { name: "Rejected", value: 3 }
            ],
            subscribeFormSubmissionsWithInfo: null,
            //pagination
            pageNo: 1,
            pageSize: 6,
            pagesCount: 0,
            totalMatches: null,
            searchString: "",
            orderBy: "",
            sortOrder: null,
            paginationTimeout: null,
            requestId: uuid4(),

            //form
            subscribeFormSubmissionFormVisible: false,
            subscribeFormSubmissionFormKey: 0,
            subscribeFormSubmissionFormSubscribeFormSubmission: new SubscribeFormSubmission(),

            showSubscribeFormLinkGenerator: false
        };
    },
    mounted: function() {
        this.getSubscribeFormSubmissions();
    },
    //activated: function(){//when keep a live is brought back up},
    components: {
        SubscribeFormSubmissionForm,
        SubscribeFormLinkGenerator
        //
    },
    methods: {
        getStatusName(id) {
            var i = this.statuses
                ? this.statuses.find(x => x.value == id)
                : null;
            return i ? i.name : "";
        },
        getSubscribeFormSubmissions() {
            var requestId = (this.requestId = uuid4());
            this.$store
                .dispatch("subscribeFormSubmissions/get", {
                    id: null,
                    urlParameters: {
                        pageNo: this.pageNo,
                        pageSize: this.pageSize,
                        searchString: this.searchString,
                        orderBy: this.orderBy,
                        sortOrder: this.sortOrder
                    },
                    requestId: requestId
                })
                .then(subscribeFormSubmissionsResponse => {
                    if (
                        this.requestId ==
                        subscribeFormSubmissionsResponse.requestId
                    ) {
                        this.subscribeFormSubmissionsWithInfo =
                            subscribeFormSubmissionsResponse.data.page;
                        this.totalMatches =
                            subscribeFormSubmissionsResponse.data.total;
                        this.pageSize =
                            subscribeFormSubmissionsResponse.data.pageSize;
                        this.pageNo =
                            subscribeFormSubmissionsResponse.data.pageNumber;
                        this.pagesCount = Math.ceil(
                            subscribeFormSubmissionsResponse.data.total /
                                this.pageSize
                        );
                    }
                });
        },
        paginationDebounce(debounceTime, isPaging) {
            if (!isPaging) {
                this.pageNo = 1;
                this.pagesCount = 0;
            }
            if (this.subscribeFormSubmissionsWithInfo !== null)
                this.subscribeFormSubmissionsWithInfo = null;
            clearTimeout(this.paginationTimeout);
            this.paginationTimeout = setTimeout(
                this.getSubscribeFormSubmissions,
                debounceTime
            );
        },
        setSearch(value) {
            this.searchString = value;
            this.paginationDebounce(1000);
        },

        //FORM METHODS---------------------------------
        newSubscribeFormSubmission() {
            var subscribeFormSubmission = new SubscribeFormSubmission();
            subscribeFormSubmission.id = 0;
            this.loadSubscribeFormSubmissionForm(subscribeFormSubmission);
        },
        loadSubscribeFormSubmissionForm(subscribeFormSubmission) {
            this.subscribeFormSubmissionFormSubscribeFormSubmission = new SubscribeFormSubmission().set(
                subscribeFormSubmission
            );
            this.subscribeFormSubmissionFormKey = subscribeFormSubmission.id;
            this.subscribeFormSubmissionFormVisible = true;
        },
        closeSubscribeFormSubmissionForm() {
            this.subscribeFormSubmissionFormVisible = false;
            this.subscribeFormSubmissionFormSubscribeFormSubmission = new SubscribeFormSubmission();
            this.subscribeFormSubmissionFormKey = null;
        },
        updateSubscribeFormSubmission() {
            this.paginationDebounce(0);
        },
        deleteSubscribeFormSubmission() {
            this.paginationDebounce(0);
        }
    }
};
</script>

<style lang="stylus" scoped>
.entity-card {
    /* background: linear-gradient(45deg, rgba(127,127,127,0.1), transparent,rgba(127,127,127,0.1)) */
    .center-content {
        background-color: rgba(127, 127, 127, 0.15);
    }
}

.pagination-bar {
    // position: fixed;
    bottom: 0;
    margin: auto;
    left: 0;
    right: 0;
    padding-bottom: 0.1rem;
    padding-top: 0.1rem;
    /*
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border:1px solid rgba(127, 127, 127, 0.2)
    */
}

.theme--light {
    .base-background {
        background: #FFFFFF;
    }
}

.theme--dark {
    .base-background {
        background: #121212;
    }
}
</style>
